import React, { ReactNode } from 'react';
import Box from '@mui/material/Box';

interface BarcodeListProps {
  children: ReactNode;
}

const BarcodeList = ({ children }: BarcodeListProps) => {
  return (
    <Box>
      <table width={'100%'} style={{ margin: '0 auto' }}>
        <thead>
          <tr>
            <th align="center" style={{ width: 40 }}></th>
            <th align="left" style={{ minWidth: 130, maxWidth: 150 }}>
              Barcode ID
            </th>
            <th align="left" style={{ width: 110 }}>
              Vol
            </th>
            <th align="left">Status</th>
            <th align="center">Action</th>
          </tr>
        </thead>

        <tbody>{children}</tbody>
      </table>
    </Box>
  );
};

export default BarcodeList;
